import { useIntl } from 'react-intl';

const useCustomTranslations = () => {
  const { formatMessage } = useIntl();

  const adyenCreditCard = {
    'creditCard.numberField.title': formatMessage({ id: 'payment.paymentMethod.creditCardForm.number' }),
    'creditCard.numberField.placeholder': formatMessage({
      id: 'payment.paymentMethod.creditCardForm.placeholders.numbers'
    }),
    'creditCard.numberField.invalid': formatMessage({ id: 'payment.paymentMethod.creditCardForm.error.invalidCard' }),
    'creditCard.expiryDateField.title': formatMessage({
      id: 'payment.paymentMethod.creditCardForm.expiration'
    }),
    'creditCard.expiryDateField.placeholder': formatMessage({
      id: 'payment.paymentMethod.creditCardForm.placeholders.expiry'
    }),
    'creditCard.expiryDateField.invalid': formatMessage({
      id: 'payment.paymentMethod.creditCardForm.error.expiry'
    }),
    'creditCard.cvcField.title': formatMessage({ id: 'payment.paymentMethod.creditCardForm.cvv' }),
    'creditCard.cvcField.placeholder': formatMessage({
      id: 'payment.paymentMethod.creditCardForm.placeholders.cvv'
    }),
    'error.va.gen.01': formatMessage({ id: 'payment.paymentMethod.creditCardForm.error.incompleteField' }),
    'error.va.gen.02': formatMessage({ id: 'payment.paymentMethod.creditCardForm.error.invalidField' }),
    'error.va.sf-cc-num.01': formatMessage({ id: 'payment.paymentMethod.creditCardForm.error.invalidCard' }),
    'error.va.sf-cc-num.02': formatMessage({ id: 'payment.paymentMethod.creditCardForm.error.cardNumberBrand' }),
    'error.va.sf-cc-num.03': formatMessage({ id: 'payment.paymentMethod.creditCardForm.error.unsupportedCard' }),
    'error.va.sf-cc-dat.01': formatMessage({ id: 'payment.paymentMethod.creditCardForm.error.cardTooOld' }),
    'error.va.sf-cc-dat.02': formatMessage({ id: 'payment.paymentMethod.creditCardForm.error.tooFarInFuture' })
  };

  return { adyenCreditCard };
};

export default useCustomTranslations;
